/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable import/prefer-default-export */
import moment from 'moment';
import React from 'react';
import {
  Space,
  Tag,
  Popconfirm,
  Progress,
} from 'antd';
import Button from 'antd-button-color';
import { Link } from 'react-router-dom';
import { CheckCircleOutlined, CloseCircleOutlined } from '@ant-design/icons';
import 'antd-button-color/dist/css/style.css';
import Can from '../../util/can';
import {
  MERCHANT_ACCOUNTS,
  MERCHANT_BENEFICIARIES,
  PERMISSIONS,
  ROLES,
  TRANSACTION_CHARGES,
  USERS,
  SETTLEMENT_REPORTS,
  PROCESSING_SUMMARIES,
  PROCESSORS,
} from '../../constants/resources';
import { TrafficTypes } from '../../constants/System';

export const userColumns = (
  handleEdit, handleApproveUser, handleVerifyUser, handleSuspendUser,
  handleNavigate, updatingUser, approvedUserId, suspendedUserId,
  // eslint-disable-next-line no-unused-vars
  verifyUserId,
) => [
    {
      title: 'First Name',
      dataIndex: 'first_name',
      width: 120,
      sorter: true,
      fixed: 'left',
      render: (name, record) => (
        <a
          aria-hidden
          data-testid={`first-name-${record._id}`}
          onClick={() => handleNavigate(record)}
        >
          {name}
        </a>
      ),
    },
    {
      title: 'Last Name',
      dataIndex: 'last_name',
      width: 120,
      fixed: 'left',
      sorter: true,
    },
    {
      title: 'Email',
      dataIndex: 'email',
      width: 220,
      sorter: true,
    },
    {
      title: 'Role',
      dataIndex: 'role',
      width: 120,
      filterMultiple: false,
      render: (name, record) => (<span>{record.role?.name}</span>),
      search: false,
      /* filters: roles
      && roles.length !== 0
        ? roles.map((role) => ({ value: role._id, text: role.name })) : [], */
    },
    {
      title: 'Approved',
      dataIndex: 'is_active',
      width: 120,
      sorter: true,
      search: false,
      render: (value, record) => {
        const isActive = record && record.is_active;
        return (
          <Space size="middle">
            <Can I="update" a={USERS}>
              <Popconfirm
                title={`Sure to ${isActive ? 'disapprove' : 'approve'}?`}
                okText="Yes"
                cancelText="No"
                onConfirm={() => handleApproveUser(record)}
              >
                <Button
                  className={!isActive ? 'ant-btn ant-btn-sm ant-tag-red' : 'ant-btn ant-btn-sm ant-tag-green'}
                  icon={!isActive ? <CloseCircleOutlined /> : <CheckCircleOutlined />}
                  loading={updatingUser && (approvedUserId === record._id)}
                >
                  {!isActive ? 'No' : 'Yes'}
                </Button>
              </Popconfirm>
            </Can>
          </Space>
        );
      },
    },
    {
      title: 'Suspended',
      dataIndex: 'is_suspended',
      width: 120,
      sorter: true,
      search: false,
      render: (value, record) => {
        const isSuspended = record && record.is_suspended;
        return (
          <Space size="middle">
            <Can I="update" a={USERS}>
              <Popconfirm
                title={`Sure to ${isSuspended ? 'un-suspend' : 'suspend'}?`}
                okText="Yes"
                cancelText="No"
                onConfirm={() => handleSuspendUser(record)}
              >
                <Button
                  className={!isSuspended ? 'ant-btn ant-btn-sm ant-tag-red' : 'ant-btn ant-btn-sm ant-tag-green'}
                  icon={!isSuspended ? <CloseCircleOutlined /> : <CheckCircleOutlined />}
                  loading={updatingUser && (verifyUserId === record._id)}
                >
                  {!isSuspended ? 'No' : 'Yes'}
                </Button>
              </Popconfirm>
            </Can>
          </Space>
        );
      },
    },
    {
      title: '',
      key: 'operation',
      fixed: 'right',
      width: 60,
      search: false,
      render: (record) => (
        <Space size="middle">
          <Can I="update" a={USERS}>
            <Button
              type="primary"
              className="ant-btn-sm ant-btn-background-ghost"
              data-testid={`update-record-${record._id}`}
              onClick={() => handleEdit({
                ...record,
                role: record.role._id,
              })}
            >
              <i className="icon icon-edit" />
            </Button>

          </Can>
        </Space>
      ),
    },
  ];

export const roleColumns = (handleDelete, handleEditRole, handleEditRecord) => [
  {
    title: 'Role',
    dataIndex: 'name',
    sorter: true,
  },
  {
    title: 'Type',
    dataIndex: 'is_system_role',
    render: (value, record) => (
      <Tag>
        {record.is_system_role ? 'System Role' : 'Merchant Role'}
      </Tag>
    ),
    filters: [
      {
        text: 'Yes',
        value: true,
      },
      {
        text: 'No',
        value: false,
      },
    ],
    filterMultiple: false,
  },
  {
    title: 'Permissions',
    dataIndex: 'permissions',
    search: false,
    render: (permissionTags) => (
      <>
        {permissionTags.map((tag) => (
          <Tag color="geekblue" key={tag + Date.now().toString()}>
            {tag}
          </Tag>
        ))}
      </>
    ),
  },
  {
    title: '',
    key: 'operation',
    search: false,
    render: (record) => (
      <Space size="middle">
        <Can I="update" a={ROLES}>
          <Button
            data-testid={`update-record-${record.key}`}
            type="primary"
            className="ant-btn-sm ant-btn-background-ghost"
            onClick={() => {
              handleEditRecord(record);
              handleEditRole(record);
            }}
          >
            <i className="icon icon-edit" />
          </Button>
        </Can>
        <Can I="delete" a={ROLES}>
          <Popconfirm title="Sure to delete?" onConfirm={() => handleDelete(record.key)}>
            <Button
              data-testid={`delete-record-${record.key}`}
              danger
              className="ant-btn-sm ant-btn-background-ghost"
            >
              <i className="icon icon-trash" />
            </Button>
          </Popconfirm>
        </Can>
      </Space>
    ),
  }];

export const permissionColumns = (handleDelete, handleEdit) => [
  {
    title: 'Permission',
    dataIndex: 'name',
    sorter: true,
  },
  {
    title: 'Resource',
    dataIndex: 'resource',
    sorter: true,
  },
  {
    title: 'Method',
    dataIndex: 'method',
    sorter: true,
  },
  {
    title: '',
    key: 'action',
    search: false,
    render: (record) => (
      <Space size="middle">
        <Can I="update" a={PERMISSIONS}>
          <Button
            data-testid={`update-record-${record._id}`}
            type="primary"
            className="ant-btn-sm ant-btn-background-ghost"
            onClick={() => handleEdit(record)}
          >
            <i className="icon icon-edit" />
          </Button>
        </Can>
        <Can I="delete" a={PERMISSIONS}>
          <Popconfirm title="Sure to delete?" onConfirm={() => handleDelete(record._id)}>
            <Button
              data-testid={`delete-record-${record._id}`}
              danger
              className="ant-btn-sm ant-btn-background-ghost"
            >
              <i className="icon icon-trash" />
            </Button>
          </Popconfirm>
        </Can>
      </Space>
    ),
  }];

export const settlementReportsColumns = (
  handleDelete, handleEdit,
) => [
    {
      title: 'Business Account',
      dataIndex: 'business_name',
      render: (value, record) => (
        <>
          <b>{(record.wallet_currency_code)}</b>
          <br />
          <br />
          {(record.business_name)}
          <div>
            <small>
              <small>
                {record._id}
                {' '}
                {record?.send_email_initiated
                  && (
                    <>
                      ✔️
                    </>
                  )}
              </small>
            </small>
          </div>
          {/* <div>
            <small>
              <small>
                author:
                {record.author_email}
              </small>
            </small>
          </div> */}
        </>
      ),
    },
    {
      title: 'Status',
      dataIndex: 'status',
      render: (value, record) => (
        <>
          <div>
            <Tag title={record.status || 'PENDING'} color={record.status === 'COMPLETED' ? 'green' : 'red'}>
              Settlement
            </Tag>
          </div>
          <div>
            <Tag title={record.rrstatus || 'PENDING'} color={record.rrstatus === 'COMPLETED' ? 'green' : 'red'}>
              Rolling Reserve
            </Tag>
          </div>
          {record?.merchant_id_parent1
            && (
              <div>
                <Tag title={record.status_parent1 || 'PENDING'} color={record.status_parent1 === 'COMPLETED' ? 'green' : 'red'}>
                  {record.business_name_parent1}
                  <small>
                    <small>
                      {' '}
                      {record?.send_email_initiated_parent1
                        && (
                          <>
                            ✔️
                          </>
                        )}
                    </small>
                  </small>
                </Tag>
              </div>
            )}
          {record?.merchant_id_parent2
            && (
              <div>
                <Tag title={record.status_parent2 || 'PENDING'} color={record.status_parent2 === 'COMPLETED' ? 'green' : 'red'}>
                  {record.business_name_parent2}
                  <small>
                    <small>
                      {' '}
                      {record?.send_email_initiated_parent2
                        && (
                          <>
                            ✔️
                          </>
                        )}
                    </small>
                  </small>
                </Tag>
              </div>
            )}
        </>
      ),
    },
    {
      title: 'Dates',
      dataIndex: 'statement_date',
      search: false,
      render: (value, records) => (
        <>
          <span style={{ fontWeight: 600 }}>Statement</span>
          <div>{moment(records.statement_date).format('DD-MMM-YY')}</div>
          <br />
          <div>{moment(records.begin_date).format('DD-MMM-YY')}</div>
          <div>{moment(records.end_date).format('DD-MMM-YY')}</div>
        </>
      ),
    },
    {
      title: 'Settlement',
      dataIndex: 'net_settlement_amount',
      search: false,
      render: (value, record) => (
        <div>
          <div>
            {new Intl.NumberFormat().format(value)}
            {' '}
            <div>{record.wallet_currency_code}</div>
          </div>
          <br />
          <div>
            {new Intl.NumberFormat().format(record.usdt_settlement_amount)}
            {' '}
            <div>USDT</div>
          </div>
        </div>
      ),
    },
    // {
    //   title: 'FX Profits',
    //   dataIndex: 'overall_usd_profit',
    //   search: false,
    //   render: (value, record) => (
    //     <div>
    //       <div>
    //         {new Intl.NumberFormat().format(record.overall_usd_profit)}
    //         {' '}
    //         <div>USD</div>
    //       </div>
    //       +
    //       <div>
    //         {new Intl.NumberFormat().format(record.overall_usdt_profit)}
    //         {' '}
    //         <div>USDT</div>
    //       </div>
    //     </div>
    //   ),
    // },
    // {
    //   title: 'Processing Profits',
    //   dataIndex: 'processing_profit',
    //   search: false,
    //   render: (value, record) => (
    //     <div>
    //       <div>
    //         {new Intl.NumberFormat().format(record.processing_profit)}
    //         {' '}
    //         <div>{record.wallet_currency_code}</div>
    //       </div>
    //     </div>
    //   ),
    // },
    {
      title: '',
      key: 'action',
      fixed: 'right',
      search: false,
      render: (record) => (
        <Space size="middle">
          {/* <Can I="update" a={SETTLEMENT_REPORTS}> */}
          <Button
            data-testid={`update-record-${record._id}`}
            type="primary"
            className="ant-btn-sm ant-btn-background-ghost"
            onClick={() => handleEdit(record)}
          >
            <i className="icon icon-edit" />
          </Button>
          {/* </Can> */}
          <Can I="delete" a={SETTLEMENT_REPORTS}>
            <Popconfirm title="Sure to delete?" onConfirm={() => handleDelete(record._id)}>
              <Button
                data-testid={`delete-record-${record._id}`}
                danger
                className="ant-btn-sm ant-btn-background-ghost"
              >
                <i className="icon icon-trash" />
              </Button>
            </Popconfirm>
          </Can>
        </Space>
      ),
    },
  ];

// eslint-disable-next-line max-len
export const merchantColumns = (handleDelete, handleEdit, navigateToMerchant, isAffilate = false) => [
  {
    title: 'Name',
    dataIndex: 'name',
    sorter: true,
    fixed: 'left',
    width: 200,
    render: (name, record) => (
      <>
        <div>
          <a aria-hidden onClick={() => navigateToMerchant(record)}>{name}</a>
          {record.enable_affiliate ? <Tag color='green'>Affiliate</Tag> : ''}
        </div>
        <br />
        <small>
          <div>owner</div>
          <div><small>{record.userDetail?.name}</small></div>
        </small>
      </>
    ),
  },
  {
    title: 'RR (%)',
    dataIndex: 'rolling_reserve',
    sorter: true,
  },
  {
    title: 'RR (Months)',
    dataIndex: 'rolling_reserve_period',
    sorter: true,
  },
  {
    title: 'Card T+ (Days)',
    dataIndex: 'card_settlement_period',
    sorter: true,
  },
  {
    title: 'Card Velocity Period (Hours)',
    dataIndex: 'card_velocity_period',
    sorter: true,
  },
  {
    title: 'Active',
    dataIndex: 'is_active',
    search: false,
    render: (value) => (
      <Tag color={value ? 'green' : 'red'}>
        {value ? 'Yes' : 'No'}
      </Tag>
    ),
    filters: [
      {
        text: 'Yes',
        value: true,
      },
      {
        text: 'No',
        value: false,
      },
    ],
    filterMultiple: false,
  },
  {
    title: '',
    key: 'action',
    search: false,
    render: (record) => (
      <Space size="middle">
        <Can I="update" a={MERCHANT_ACCOUNTS}>
          <Button
            data-testid={`update-record-${record._id}`}
            type="primary"
            className="ant-btn-sm ant-btn-background-ghost"
            onClick={() => handleEdit(record)}
          >
            <i className="icon icon-edit" />
          </Button>
        </Can>
        <Can I="delete" a={MERCHANT_ACCOUNTS}>
          <Popconfirm title="Sure to delete?" onConfirm={() => handleDelete(record._id)}>
            <Button
              data-testid={`delete-record-${record._id}`}
              danger
              className="ant-btn-sm ant-btn-background-ghost"
            >
              <i className="icon icon-trash" />
            </Button>
          </Popconfirm>
        </Can>
      </Space>
    ),
  },
];

export const ProcessingSummariesColumns = (handleDelete, handleEdit) => [
  {
    title: 'Name',
    dataIndex: 'service_type',
    sorter: false,
    search: true,
    render: (value, data) => (
      <>
        <div><b>{data.currency}</b></div>
        <br />
        <small>
          <div>{data.service_type}</div>
          <div><small>{data.name}</small></div>
        </small>
      </>
    ),
  },
  {
    title: 'Range',
    dataIndex: 'date_from',
    sorter: false,
    search: false,
    render: (value, records) => (
      <>
        <div>
          {moment(records.date_from).utc().add(3, 'hours').format('DD-MMM-YYTHH:mm')}
          {' '}
          am
        </div>
        <div>
          (
          {(records.timezone)}
          )
        </div>
        <br />
        <div>
          {moment(records.date_to).utc().add(3, 'hours').format('DD-MMM-YYTHH:mm')}
          {' '}
          pm
        </div>
        <div>
          (
          {(records.timezone)}
          )
        </div>
      </>
    ),
  },
  {
    title: 'COMPLETED',
    dataIndex: 'completed_amount',
    sorter: false,
    search: false,
    render: (value, record) => (
      <>
        <div>
          {new Intl.NumberFormat().format(record.completed_count)}
        </div>
        <div>
          (Count)
        </div>
        <br />
        <div>
          {new Intl.NumberFormat().format(record.completed_amount)}
        </div>
        <div>
          (
          {(record.currency)}
          )
        </div>
      </>
    ),
  },
  {
    title: 'FAILED',
    dataIndex: 'failed_amount',
    sorter: false,
    search: false,
    render: (value, record) => (
      <>
        <div>
          {new Intl.NumberFormat().format(record.failed_count)}
        </div>
        <div>
          (Count)
        </div>
        <br />
        <div>
          {new Intl.NumberFormat().format(record.failed_amount)}
        </div>
        <div>
          (
          {(record.currency)}
          )
        </div>
      </>
    ),
  },
  {
    title: 'next',
    dataIndex: 'next_summary_created',
    sorter: false,
    search: false,
    render: (value, record) => (
      <>
        <div>
          {moment(record.next_date_from).utc().add(3, 'hours').format('DD-MMM-YYTHH:mm')}
          {' '}
          am
        </div>
        <div>
          {moment(record.next_date_to).utc().add(3, 'hours').format('DD-MMM-YYTHH:mm')}
          {' '}
          pm
        </div>

        <br />
        {value === true ? 'Next Executed on' : 'Next Will Execute on'}
        <div>
          {moment(record.next_summary_date).utc().add(3, 'hours').format('DD-MMM-YYTHH:mm')}
          {' '}
          am
        </div>
      </>
    ),
  },
  {
    title: '',
    key: 'action',
    render: (record) => (
      <Space size="middle">
        <Can I="update" a={PROCESSING_SUMMARIES}>
          <Button
            type="primary"
            className="ant-btn-sm ant-btn-background-ghost"
            data-testid={`update-record-${record._id}`}
            onClick={() => handleEdit(record)}
          >
            <i className="icon icon-edit" />
          </Button>
        </Can>
        <Can I="delete" a={PROCESSING_SUMMARIES}>
          <Popconfirm
            title="Sure to delete?"
            onConfirm={() => handleDelete(record._id)}
          >
            <Button
              danger
              className="ant-btn-sm ant-btn-background-ghost"
              data-testid={`delete-record-${record._id}`}
            >
              <i className="icon icon-trash" />
            </Button>
          </Popconfirm>
        </Can>
      </Space>
    ),
  }];

export const ProcessorsColumns = (
  handleDelete,
  handleEditProcessor,
  handleEditRecord,
  createAcquirerReport,
  isMerchant,
  transactionProcessedData = []
) => [
    {
      title: 'Mid Name',
      dataIndex: 'name',
      sorter: true,
      width: 220,
      fixed: 'left',
      render: (name, record) => {
        const processorData = transactionProcessedData.find(d => d.processor === record._id);

        // Calculate depletion percentage based on daily limit usage
        const dailyLimit = record.daily_limit_amount || 0;
        const successValue = processorData ? processorData.success_value : 0;
        const depletionPercent = dailyLimit > 0
          ? Math.min(((successValue / dailyLimit) * 100), 100).toFixed(2)
          : 0;

        // Determine progress bar color based on depletion level
        let progressColor = '#52c41a'; // green - good (0-25% used)
        if (depletionPercent >= 100) {
          progressColor = '#f5222d'; // red - fully depleted
        } else if (depletionPercent >= 75) {
          progressColor = '#ff7a00'; // orange - critical (75-99%)
        } else if (depletionPercent >= 50) {
          progressColor = '#fa8c16'; // orange - high (50-74%)
        } else if (depletionPercent >= 25) {
          progressColor = '#faad14'; // gold - moderate (25-49%)
        }

        const color = record.is_active ? 'success' : 'error';
        const approvalRatio = processorData && processorData.success && (processorData.success + processorData.failed)
          ? ((processorData.success / (processorData.success + processorData.failed)) * 100).toFixed(2)
          : 'N/A';
        const FailureRatio = processorData && processorData.success && (processorData.success + processorData.complete_failed)
          ? ((processorData.success / (processorData.success + processorData.complete_failed)) * 100).toFixed(2)
          : 'N/A';

        return (
          <>
            <Link to={`/processors/${record._id}/${record._id}`}>
              <span className="ant-badge ant-badge-status ant-badge-not-a-wrapper">
                <span className={`ant-badge-status-dot ant-badge-status-${color}`} />
                <span className="ant-badge-status-text">{name}</span>
              </span>
            </Link>
            <br />
            {record.mid_biz_name && (
              <Tag color="blue">{record.mid_biz_name}</Tag>
            )}

            {processorData && (
              <>
                <div style={{ fontSize: '12px', color: '#666' }}>
                  Count ~ ST: {processorData.success} | FT: {processorData.failed} | AFT: {processorData.complete_failed} | AR: {approvalRatio}% | SR: {FailureRatio}%
                </div>
                <div style={{ fontSize: '12px', color: '#666' }}>
                  Volume ~ ST: {processorData.success_value} | FT: {processorData.failed_value} | AFT: {processorData.complete_failed_value}
                </div>
                {record.message && (
                  <div style={{ fontSize: '12px', color: '#d4380d', marginTop: '4px' }}>
                    {record.message}
                  </div>
                )}
                {record.is_active && (
                  <div style={{ marginTop: '4px' }}>
                    <Progress
                      percent={parseFloat(depletionPercent)}
                      strokeColor={progressColor}
                      size="small"
                      format={(percent) => `${percent}% of daily limit`}
                    />
                  </div>
                )}
              </>
            )}
          </>
        );
      },
    },
    {
      title: 'Scheme',
      dataIndex: 'service_type',
      width: 50,
      sorter: true,
      search: false,
      filterMultiple: false,
    },
    {
      title: 'Payment Method',
      dataIndex: 'payment_method',
      width: 100,
      sorter: true,
      search: false,
      filterMultiple: false,
      render: (payment_method, record) => {
        return (
          <>
           <div>
                {payment_method}
            </div>
            {record.card_types && (
              record.card_types.map((tag) => (
                <Tag color="green" key={tag}>
                  {tag}
                </Tag>
              ))
            )}
          </>
        );
      }
    },
    {
      title: 'Currency',
      dataIndex: 'currency',
      width: 50,
      sorter: true,
      search: false,
      filterMultiple: false,
    },
    {
      title: 'Traffic Type',
      dataIndex: 'traffic_types',
      width: 100,
      search: false,
      render: (trafficTypesTags) => {
        if (trafficTypesTags !== null) {
          return trafficTypesTags.map((tag) => (
            <Tag color="geekblue" key={tag}>
              {tag}
            </Tag>
          ));
        }
        return (
          <Tag color="geekblue">
            -None-
          </Tag>
        );
      },
      sorter: false,
      filterMultiple: false,
      filters: TrafficTypes
        && TrafficTypes.length !== 0
        ? TrafficTypes.map((type) => ({ value: type, text: type })) : [],
      onFilter: (value, record) => record.traffic_types.find((type) => type === value),
    },
    {
      title: '',
      key: 'action',
      fixed: `${isMerchant ? '' : 'right'}`,
      width: 120,
      render: (record) => (
        <Space size="middle">
          <Can I="read" a={PROCESSING_SUMMARIES}>
            <Button
              type="success"
              data-testid={`create - acquirer - report - ${record._id}`}
              className="ant-btn-sm ant-btn-background-ghost"
              onClick={() => {
                createAcquirerReport(record);
              }}
            >
              <i className="icon icon-files" />
            </Button>
          </Can>
          <Can I="update" a={PROCESSORS}>
            <Button
              type="primary"
              data-testid={`update - record - ${record._id}`}
              className="ant-btn-sm ant-btn-background-ghost"
              onClick={() => {
                handleEditRecord(record);
                handleEditProcessor(record);
              }}
            >
              <i className="icon icon-edit" />
            </Button>
          </Can>
          <Can I="delete" a={PROCESSORS}>
            <Popconfirm
              title="Sure to delete?"
              onConfirm={() => handleDelete(record._id)}
            >
              <Button
                data-testid={`delete -record - ${record._id}`}
                danger
                className="ant-btn-sm ant-btn-background-ghost"
              >
                <i className="icon icon-trash" />
              </Button>
            </Popconfirm>
          </Can>
        </Space>
      ),
    }];

export const merchantBeneficiaryColumns = (
  handleDelete, handleEdit, merchants, selectedMerchant, handleTesting,
) => [
    {
      title: 'Business Account',
      dataIndex: ['merchant', 'name'],
      filterMultiple: false,
      filters: merchants
        && merchants.length !== 0
        ? merchants.map((merchant) => ({ value: merchant._id, text: merchant.name })) : [],
    },
    {
      title: 'Currency',
      dataIndex: 'currency',
      filterMultiple: false,
    },
    {
      title: 'Transaction Type',
      dataIndex: ['transaction_type'],
      filterMultiple: false,
    },
    {
      title: 'Fixed Charge',
      dataIndex: 'fixed_charge',
      render: (charge) => <span>{new Intl.NumberFormat().format(charge)}</span>,
      sorter: true,
    },
    {
      title: 'Percentage Charge',
      dataIndex: 'percentage_charge',
      render: (percentageCharge) => <span>{`${percentageCharge} % `}</span>,
      sorter: true,
    },
    ...(selectedMerchant ? [{
      title: '',
      key: 'action',
      render: (record) => (
        <Space size="middle">
          <Can I="update" a={MERCHANT_BENEFICIARIES}>
            <Button
              type="primary"
              className="ant-btn-sm ant-btn-background-ghost"
              onClick={() => handleEdit(record)}
            >
              <i className="icon icon-edit" />
            </Button>

          </Can>
          <Button
            type="info"
            className="ant-btn-sm ant-btn-background-ghost"
            onClick={() => handleTesting(record)}
          >
            TEST
          </Button>
          <Can I="delete" a={MERCHANT_BENEFICIARIES}>
            <Popconfirm
              title="Sure to delete?"
              onConfirm={() => handleDelete(record._id)}
            >
              <Button
                danger
                className="ant-btn-sm ant-btn-background-ghost"
              >
                <i className="icon icon-trash" />
              </Button>
            </Popconfirm>
          </Can>
        </Space>
      ),
    }] : []),
  ];

export const TransactionChargesColumns = (
  handleDelete,
  handleEdit,
  handleEditRecord,
  processors,
) => [
    {
      title: 'Provider',
      dataIndex: 'provider',
      width: 130,
      render: (val) => (
        <span>
          {val}
        </span>
      ),
      sorter: true,
      search: false,
      filterMultiple: false,
    },
    {
      title: 'Transaction Type',
      dataIndex: ['transaction_type'],
      filterMultiple: false,
    },
    {
      title: 'PSP Charge',
      dataIndex: 'processor_percentage_charge',
      width: 180,
      render: (val, record) => (`${record.processor_percentage_charge} % + ${record.processor_fixed_charge?.toLocaleString('en-US')} ${record.currency}`),
    },
    {
      title: 'Our charges',
      dataIndex: 'p2p_percentage_charge',
      width: 180,
      render: (val, record) => (`${record.p2p_percentage_charge} % + ${record.p2p_fixed_charge?.toLocaleString('en-US')} ${record.currency}`),
    },
    {
      title: 'Traffic Type',
      dataIndex: 'traffic_types',
      width: 180,
      search: false,
      render: (trafficTypesTags) => {
        if (trafficTypesTags !== null) {
          return trafficTypesTags.map((tag) => (
            <Tag color="geekblue" key={tag}>
              {tag}
            </Tag>
          ));
        }
        return (
          <Tag color="geekblue">
            -None-
          </Tag>
        );
      },
      sorter: false,
      filterMultiple: false,
    },
    {
      title: '',
      dataIndex: 'is_active',
      width: 30,
      fixed: 'right',
      render: (isActive) => {
        const active = isActive === 'true' || isActive === true;
        return (
          <span title={`${active ? 'active' : 'not-active'}`} className="gx-follower-title gx-fs-lg gx-font-weight-medium">
            <span className="ant-badge-status ant-badge-not-a-wrapper">
              <span className={`ant - badge - status - dot ant - badge - status - ${active ? 'green' : 'red'}`} />
            </span>
          </span>
        );
      },
    },
    {
      title: 'Action',
      key: 'action',
      fixed: 'right',
      width: 100,
      search: false,
      render: (record) => (
        <Space size="middle">
          <Can I="update" a={TRANSACTION_CHARGES}>
            <Button
              data-testid={`update - record - ${record._id}`}
              type="primary"
              className="ant-btn-sm ant-btn-background-ghost"
              onClick={() => {
                handleEdit(record);
                handleEditRecord(record);
              }}
            >
              <i className="icon icon-edit" />
            </Button>
          </Can>
          <Can I="delete" a={TRANSACTION_CHARGES}>
            <Popconfirm
              title="Sure to delete?"
              onConfirm={() => handleDelete(record._id)}
            >
              <Button
                size="small"
                data-testid={`delete -record - ${record._id}`}
                danger
              >
                <i className="icon icon-trash" />
              </Button>
            </Popconfirm>
          </Can>
        </Space>
      ),
    }];
